import { createFileRoute } from '@tanstack/react-router';
import { type PinsProps } from './-models/props';
import { ModuleName, Screen, templates, type SkinPageConfig } from '@nosinovacao/nosid-mfe-common';
import { PinsLight, PinsWooDark, PinsWoo } from './-skins';
import { ErrorSidePanel } from '@/components/errors';
import { useGetAccountPins } from './-hooks/pins.hooks';

export const Route = createFileRoute('/(tv)/tv/$id/(pins)/_sheet/pins/(pins)/')({
  component: RouteComponent,
  errorComponent: ErrorSidePanel,
  staticData: {
    module: ModuleName.Tv,
    screen: Screen.Pins,
  },
});

function RouteComponent() {
  const { id } = Route.useParams();
  const { data: pins, isLoadingData } = useGetAccountPins(id);
  const props: PinsProps = {
    loading: isLoadingData,
    pins: pins ?? [],
    id,
  };
  return templates.getSkinSelector(getSkinConfig(props));
}

function getSkinConfig(props: PinsProps): SkinPageConfig {
  return {
    skins: [
      {
        selector: 'isWooTvTemplate',
        component: <PinsWooDark {...props} />,
      },
      {
        selector: 'isWooTemplate',
        component: <PinsWoo {...props} />,
      },
    ],
    defaultValue: <PinsLight {...props} />,
  };
}
